import { Scorm } from "app/core/tracking/scorm";
import { Config } from "app/core/vo/config";
import { AICC } from "app/core/tracking/aicc";
import { CMI5 } from "app/core/tracking/cmi5";
import { XAPI } from "app/core/tracking/xapi";
import { Disabled } from "app/core/tracking/disabled";
import { BaseTracking } from "app/core/tracking/base-tracking";
import { HttpService } from "../../services/http.service";
import { Scorm2004 } from "./scorm2004";
import { UtilityScripts } from "app/helpers/utility-scripts";

export class TrackingFactory {
	private static readonly SCORM_VAL: string = "scorm";
	private static readonly SCORM_2004_VAL: string = "scorm2004";
	private static readonly AICC_VAL: string = "aicc";
	private static readonly CMI5_VAL: string = "cmi5";
	private static readonly XAPI_VAL: string = "xapi";
	private static readonly DISABLED_VAL: string = "disabled";

	private static _instance: TrackingFactory = null;
	private static _singletonEnforcer: Boolean;

	private _trackingObj: BaseTracking;

	constructor() {
		if (!TrackingFactory._singletonEnforcer) {
			throw new Error(
				"This is a singleton class. Use TrackingFactory.instance to get the instance!!"
			);
		}
	}

	public static get instance(): TrackingFactory {
		if (this._instance == null) {
			this._singletonEnforcer = true;
			this._instance = new TrackingFactory();
			this._singletonEnforcer = false;
		}
		return this._instance;
	}

	public getTrackingObj(data, _httpService, appService): BaseTracking {
		let objParams: any = UtilityScripts.getConfigDetailsFromLocation(
			document.location.search.substr(1).split("&")
		);
		let isXAPI = false;
		let isCMI5 = false; //(objParams.endpoint)?true:false;
		if (objParams.content_token) isXAPI = true;
		else if (objParams.endpoint) isCMI5 = true;

		if (!this._trackingObj) {
			let httpService: HttpService;
			if (isXAPI) {
				httpService = _httpService;
				this._trackingObj = new XAPI();
			} else if (isCMI5) {
				httpService = _httpService;
				this._trackingObj = new CMI5();
			} else {
				switch (data.trackMode) {
					case TrackingFactory.SCORM_VAL:
						this._trackingObj = new Scorm();
						break;
					case TrackingFactory.SCORM_2004_VAL:
						this._trackingObj = new Scorm2004();
						break;
					case TrackingFactory.AICC_VAL:
						console.log("AICC: switch case");
						httpService = _httpService;
						this._trackingObj = new AICC();
						break;
					default:
						this._trackingObj = new Disabled();
				}
			}
			this._trackingObj.init(data, httpService, appService);
		}
		return this._trackingObj;
	}

	public get trackingObj(): BaseTracking {
		return this._trackingObj;
	}
}
